import { useEffect, useState } from "react";
import { fetchTaxCodes, downloadTaxCodesExcel } from "../Api/ViewTaxCodeLogistics";
import { Container, Table, Button } from "react-bootstrap";

import { toast } from "react-toastify";
import moment from "moment";

const ViewTaxCodeLogistics = () => {
  const [taxCodes, setTaxCodes] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    const loadTaxCodes = async () => {
      try {
        const data = await fetchTaxCodes();
        setTaxCodes(data || []);
      } catch (error) {
        toast.error(`🦄 Error Fetching Tax Codes`);
      }
    };

    loadTaxCodes();
  }, []);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const response = await downloadTaxCodesExcel();
      
      // Check if response contains data
      if (!response.data) {
        throw new Error("No data received from server");
      }
      
      // Create a blob from the response
      const url = window.URL.createObjectURL(new Blob([response.data]));
      
      // Create a link element
      const link = document.createElement('a');
      link.href = url;
      
      // Set the download attribute with a filename
      link.setAttribute('download', 'TaxCodes.xlsx');
      
      // Append to the body, click and remove
      document.body.appendChild(link);
      link.click();
      
      // Clean up
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
      }, 100);
      
      toast.success("Download started successfully!");
    } catch (error) {
      console.error("Download error:", error);
      toast.error(`🦄 Error Downloading Tax Codes: ${error.message}`);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <>
      
        <div className="main-content expand">
          <Container fluid className="list-container">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <span className="list-title">View Tax Codes</span>
              <Button className="generate-btn"
                variant="primary" 
                onClick={handleDownload}
                disabled={isDownloading || taxCodes.length === 0}
              >
                {isDownloading ? 'Downloading...' : 'Download Data'}
              </Button>
            </div>

            {taxCodes.length > 0 ? (
              <div className="table-wrapper">
                <div className="table-scroll-container">
                  <Table bordered hover className="data-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Code</th>
                        <th>Description</th>
                        <th>Type</th>
                        <th>CGST (%)</th>
                        <th>SGST (%)</th>
                        <th>IGST (%)</th>
                        <th>Created At</th>
                        <th>Created By</th>
                      </tr>
                    </thead>
                    <tbody>
                      {taxCodes.map((taxCode, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{taxCode.code}</td>
                          <td>{taxCode.description}</td>
                          <td>{taxCode.type}</td>
                          <td>{taxCode.cgst}</td>
                          <td>{taxCode.sgst}</td>
                          <td>{taxCode.igst}</td>
                          <td>{moment(taxCode.createdAt).format('L')} at {moment(taxCode.createdAt).format('LTS')}</td>
                          <td>{taxCode.createdBy}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            ) : (
              <p className="no-data">No tax codes found.</p>
            )}
          </Container>
        </div>
      
    </>
  );
};

export default ViewTaxCodeLogistics;